import { call, put, select, takeEvery } from "redux-saga/effects"
import { map, pick } from "lodash"
import { createActions, createReducer } from "reduxsauce"
import { put as apiPut, del as apiDel } from "api"
import { Creators as modelCreators } from "model/data"
import { log } from "helpers/logger"

export const { Types, Creators } = createActions({
  deletePreferences: ["items"],
  savePreferences: ["items"],
  updatePreferencesSuccess: ["action"],
  lastPreferenceRedirect: ["preferenceType", "redirectedTo", "defaultRedirectTo"],
}, {
  prefix: "ompnt/modules/preferences/",
})

const DEFAULT_STATE = {
  lastPreferenceRedirect: null,
}

const handleLastPreferenceRedirect = (state, lastPreferenceRedirect) => ({ ...state, lastPreferenceRedirect })

export const reducer = createReducer(DEFAULT_STATE, {
  [Types.LAST_PREFERENCE_REDIRECT]: handleLastPreferenceRedirect,
})

const ENDPOINT = "/api/users/me/preferences"

function* callUpdatePreference(action) {
  const { accountId, currentState } = yield select(state => ({
    accountId: state.global.selected.accountId,
    currentState: state,
  }))

  const updatePreferenceMeta = action.meta.updatePreference

  let originalItems
  if (typeof updatePreferenceMeta.getItems === "function") {
    originalItems = updatePreferenceMeta.getItems(currentState, action)
  }

  if (originalItems) {
    const items = map(originalItems, item => {
      const prefItem = pick(item, "key", "type", "value")
      if (!item.noAccountId) {
        prefItem.accountId = accountId
      }
      return prefItem
    })

    try {
      let apiCall = apiPut

      if (updatePreferenceMeta.actionType === "delete") {
        apiCall = apiDel
      }

      yield call(apiCall, ENDPOINT, { items })

      yield put(Creators.updatePreferencesSuccess(action))

      for (const item of originalItems) {
        if (item.updateCollection) {
          yield put(modelCreators.updateSuccess(
            item.updateCollection.resource,
            item.updateCollection.id,
            [item],
          ))
        }
      }
    } catch (err) {
      // Nothing to do about it other than logging the error, do not raise an error if preference wasn't saved
      yield call(log, err)
    }
  }
}

function* callDeletePreferences({ items }) {
  try {
    yield call(apiDel, ENDPOINT, {
      items,
    })
  } catch (err) {
    // Nothing to do about it other than logging the error, do not raise an error if preference wasn't saved
    yield call(log, err)
  }
}

function* callSavePreferences({ items }) {
  try {
    yield call(apiPut, ENDPOINT, {
      items,
    })
  } catch (err) {
    // Nothing to do about it other than logging the error, do not raise an error if preference wasn't saved
    yield call(log, err)
  }
}

export function* saga() {
  yield takeEvery(action => action.meta && action.meta.updatePreference, callUpdatePreference)
  yield takeEvery(Types.SAVE_PREFERENCES, callSavePreferences)
  yield takeEvery(Types.DELETE_PREFERENCES, callDeletePreferences)
}
